export default "__VITE_ASSET__BrOwKCio__"